import { memo } from "react";

interface EllipseProps {
  variant: "A" | "B" | "C";
  stroke: string;
  strokeWidth: string;
  opacity?: string;
  filter?: string;
}

const Ellipse = memo(
  ({ variant, stroke, strokeWidth, opacity, filter }: EllipseProps) => {
    const transformDict = {
      A: "matrix(-0.998499 -0.0547759 -0.0547759 0.998499 1217.68 138.477)",
      B: "matrix(-1 0 0 1 1205.81 106.604)",
      C: "matrix(-0.998499 0.0547759 0.0547759 0.998499 1192.21 75.4292)",
    };

    return (
      <ellipse
        cx="575.5"
        cy="230.529"
        rx="575.5"
        ry="230.529"
        transform={transformDict[variant]}
        stroke={stroke}
        strokeWidth={strokeWidth}
        filter={filter}
        opacity={opacity}
        style={{ transition: "opacity 1s" }}
      />
    );
  },
);

Ellipse.displayName = "Ellipse";
export { Ellipse };
